import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.modals_info.modal,
    (modal) => {
        return {
            modal
        }
    }
)